export default __webpack_public_path__ + "static/media/ars-maquette-bold-webfont.be183c0b.ttf";